module.exports = __webpack_public_path__ + "static/media/logo_altyor.65f2e2c3.png";